export enum UserPermissions {
  // General Profile
  ViewProfile = 'general_profile_view',
  UpdateProfile = 'general_profile_update',
  NotifyClaimSets = 'general_notifications_updates_claimset',
  NotifyClaims = 'general_notifications_updates_claim',
  NotifyClaimants = 'general_notifications_updates_claimant',
  NotifyTasks = 'general_notifications_updates_task',
  NotifyNotes = 'general_notifications_updates_note',
  NotifyDocuments = 'general_notifications_updates_document',
  NotifyInsureds = 'general_notifications_updates_insured',
  NotifyBeneficiaries = 'general_notifications_updates_beneficiary',
  NotifyProducers = 'general_notifications_updates_producer',
  NotifyContacts = 'general_notifications_updates_contact',
  NotifyCoverages = 'general_notifications_updates_coverage',
  NotifyPolicies = 'general_notifications_updates_policy',
  NotifyPersons = 'general_notifications_updates_person',
  NotifyBusinesses = 'general_notifications_updates_business',
  EditOTP = 'general_otp_preference_edit',
  EditNotifications = 'general_notification_preference_edit',
  ChangePassword = 'general_password_change',

  // Examiner Portal - Documents
  ViewAndDownloadDocuments = 'ep_entity_document_view_and_download',

  // Examiner Portal - Notes
  EditNote = 'update_note_permission',
  DeleteNote = 'delete_note_permission',

  // Examiner Portal - System
  ViewSystemTab = 'ep_system_button',
  SearchUsers = 'ep_search_users',
  ViewUserDetails = 'ep_view_user_details',
  EditUserDetails = 'ep_view_edit_details',
  EnableUsers = 'ep_enable_users',
  DisableUsers = 'ep_disable_users',
  DisableQueuesActions = 'ep_queue_configuration',
  DisableProducersActions = 'ep_producer_configuration',
}
